
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 8.5h100v82.9H0z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"xlink:href":"#a","overflow":"visible"}})]),_c('g',{attrs:{"clip-path":"url(#b)"}},[_c('defs',[_c('path',{attrs:{"id":"c","d":"M0 8.5h100v82.9H0z"}})]),_c('clipPath',{attrs:{"id":"d"}},[_c('use',{attrs:{"xlink:href":"#c","overflow":"visible"}})]),_c('path',{attrs:{"d":"M51.2 47.6c0 7.3-5.9 13.3-13.2 13.3-7.3 0-13.2-6-13.2-13.3 0-7.3 5.9-13.3 13.2-13.3 7.3 0 13.2 6 13.2 13.3zm15.3-6.8l8.4-4.9-8.4-14.6-8.4 4.9c-3.3-3.1-7.3-5.4-11.7-6.7V9.6H29.6v9.8c-4.4 1.3-8.4 3.6-11.7 6.7l-8.4-4.9-8.4 14.7 8.4 4.9c-1.1 4.9-1.1 8.7 0 13.6l-8.4 4.9 8.4 14.6 8.4-4.9c3.3 3.1 7.3 5.4 11.7 6.7v9.8h16.8v-9.8m41-5L76.1 81.4 64.9 70.7m11.2 10.7V56m22.8 12.7c0 12-10.2 21.7-22.8 21.7-12.6 0-22.8-9.7-22.8-21.7S63.5 47 76.1 47c12.6.1 22.8 9.8 22.8 21.7z","clip-path":"url(#d)","fill":"none","stroke":"#231f20","stroke-width":"2.171","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10"}})])])
          )
        }
      }
    